import { TimerUser } from '@/entities/User/User'
import { getUniqueArrayList } from '@/helpers/array'

export const getUpdatedUsers = (users: TimerUser[], newUsers: TimerUser[]): TimerUser[] => {
    const uniqueUsersByEmployeeNumber = getUniqueArrayList<TimerUser>([...users, ...newUsers], 'employeeNumber')
    const uniqueUsersById = getUniqueArrayList<TimerUser>(uniqueUsersByEmployeeNumber, 'id')

    return uniqueUsersById
}
